import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you are looking for does not exist." />
      <section className="min-h-[80vh] flex items-center justify-center bg-paper pt-24 pb-24">
        <div className="text-center px-6">
          <p className="kicker mb-6">404</p>
          <h1 className="font-display text-5xl md:text-7xl text-ink leading-tight">Page not found.</h1>
          <p className="mt-6 font-serif text-xl text-ink/70 max-w-xl mx-auto">
            The page you are looking for has either been moved or never existed.
          </p>
          <div className="mt-10">
            <Link to="/" className="btn-primary" data-testid="notfound-home">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
}
